import { createI18n } from 'vue-i18n';
import fr from './locales/fr.json';
import en from './locales/en.json';

// Supported languages
const supportedLocales = ['fr', 'en'];

// Detect browser language
const getBrowserLocale = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  // Get the first 2 characters (e.g., 'fr-FR' -> 'fr')
  const shortLang = browserLang.split('-')[0];
  // Return the language if supported, otherwise default to 'fr'
  return supportedLocales.includes(shortLang) ? shortLang : 'fr';
};

// Get saved language from localStorage, or detect from browser, or default to French
const getInitialLocale = () => {
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale && supportedLocales.includes(savedLocale)) {
    return savedLocale;
  }
  return getBrowserLocale();
};

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getInitialLocale(),
  fallbackLocale: 'fr',
  messages: {
    fr,
    en
  }
});

// Helper function to change language
export const setLocale = (locale) => {
  if (supportedLocales.includes(locale)) {
    i18n.global.locale.value = locale;
    localStorage.setItem('locale', locale);
    document.documentElement.setAttribute('lang', locale);
  }
};

// Get current locale
export const getLocale = () => i18n.global.locale.value;

// Get available locales
export const getAvailableLocales = () => supportedLocales;

export default i18n;

